import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("img", {
      alt: "英荔 AI 创造乐园",
      class: "logo",
      src: "https://ecourse.aimaker.space/LOGO/aimaker_logo.png"
    }, null, -1)
  ])))
}